// Lib
import Tracking from 'lib/tracking';
import { component } from 'picoapp';

import { setCSSProperty } from 'utils/css';

// Utils
import choozy from 'utils/choozy';

export default component((node) => {
  const { stlFormInner } = choozy(node);

  const resizeObserver = new ResizeObserver(() => {
    setCSSProperty(node, '--inner-height', `${stlFormInner.offsetHeight}px`);
  });

  resizeObserver.observe(stlFormInner);

  node.addEventListener('click', (event) => Tracking.selectItemCallback(event, false, false));
});
